import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "mail-icon",
  role: "img",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M28.999 9.48851V22C28.999 24.7616 26.7606 27 23.999 27H7.99902C5.23741 27 2.99902 24.7616 2.99902 22V9.40133C2.99902 9.32187 3.00829 9.24457 3.02581 9.17046C3.14586 6.84684 5.06768 5 7.42119 5H24.5985C27.0297 5 28.9999 6.97064 28.9999 9.40267C28.9999 9.43132 28.9996 9.45993 28.999 9.48851ZM4.99902 13.0769V22C4.99902 23.657 6.34197 25 7.99902 25H23.999C25.6561 25 26.999 23.657 26.999 22V13.0916L21.0597 17.1184C18.0102 19.1853 14.0096 19.1854 10.9601 17.1184L4.99902 13.0769ZM26.9996 9.368C26.9992 9.37951 26.999 9.39106 26.999 9.40267V9.46602C26.9787 10.2387 26.5868 10.9559 25.9454 11.3896L24.1547 12.6037L19.9375 15.4629C17.5656 17.0705 14.4541 17.0705 12.0823 15.4629L6.07414 11.3895C5.49963 11.0002 5.12635 10.3855 5.03938 9.70733C5.02646 9.60656 5.01986 9.50438 5.01986 9.40133C5.01986 8.07495 6.09481 7 7.42119 7H24.5985C25.9131 7 26.9811 8.05604 26.9996 9.368Z"
    }, null, -1)
  ])))
}
export default { render: render }